import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { Input, Row, Card, Form, DatePicker, Col, Divider, Spin } from "antd";
import TransferCustomers from "./TransferCustomers";
import ManageMembers from "./ManageMembers";
import AddCustomer from "./AddCustomer";


const { TextArea } = Input;
const ManageClientsActionPage = (props) => {
    const { userData } = props;
    const { state } = useLocation();

    useEffect(() => {
        // console.log(state);
    }, []);

    const renderActions = () => {
        switch (state?.actionLabel?.toLowerCase()) {
            case "transfer customers":
                return <TransferCustomers userData={userData} />;
            case "manage members":
                return <ManageMembers userData={userData} />;
            case "add customer":
                return <AddCustomer userData={userData} />;
            default:
                return <>No {state.actionLabel} Component found contact dev</>;
        }
    };
    return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(ManageClientsActionPage);
